import AppService from '@/services/PricingService.js'
const namespaced = true
const state = {
    code: '',
    updated_id: '',
    lists: [],
    total_count: '',
    is_no_records: 0,
    message: {},
    list: {}

}
const mutations = {
    STATUS_DETAILS(state, data) {
        state.message = data.data.status;
        state.type = data.data.type;
    },
    LIST_DATA(state, list) {
        state.list = list
        state.error = ''
    },
    STATUS_CODE(state, code) {
        state.code = code
        state.error = ''
    },
    SET_DATAS(state, lists) {
        state.lists = lists.coupon_list
        state.is_no_records = lists.is_no_records
    },
    CANCEL_STATUS(state, data) {
        state.message = data
        state.error = ''
    }
}
const actions = {
    fetchLists({
        commit,
        rootState
    }) {

        return AppService.discountcoupon.getCoupons(rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    createList({
        commit,
        rootState
    }, list) {

        return AppService.discountcoupon.postCoupon(list, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.status == 201) {
                    commit('CANCEL_STATUS', response.data.data)
                } else {
                    commit('LIST_ID', response.data.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    updateList({
        commit,
        rootState
    }, {
        id,
        field
    }) {
        return AppService.discountcoupon.postCouponUpdate(field, id, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.status == 201) {
                    commit('CANCEL_STATUS', response.data.data)
                } else {
                    commit('LIST_ID', response.data.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchList({
        commit,
        rootState
    }, id) {
        return AppService.discountcoupon.getCouponView(id, rootState.session.token)
            .then(response => {
                commit('LIST_DATA', response.data)
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchProducts({
        rootState
    }, data) {
        return AppService.discountcoupon.getProductList(data, rootState.session.token)
            .then(response => {
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    fetchCustomers({
        rootState
    }, data) {
        return AppService.discountcoupon.getCustomerList(data, rootState.session.token)
            .then(response => {
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    deletecoupon({
            commit,
            rootState
        },
        data
    ) {
        return AppService.discountcoupon.deletecoupon(data, rootState.session.token)
            .then(response => {
                commit("STATUS_DETAILS", response);
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    }
}
export default {
    namespaced,
    state,
    mutations,
    actions
}